export enum UserStatus {
    PREMIUM = "premium",
    TRIAL = "trial",
    UNVERIFIED = "unverified",
    PASSED = "passed",
    DECLINED = "declined",
}
